/* LA ESCALERA DEL ENVÍO.
 *
 * Por qué existe: desde el 13-sep-2026 el porte baja por tramos (4,95 · 3,95 ·
 * 2,95 · gratis desde 70 €). Una tarifa escalonada que el cliente no ve es solo
 * una subida de precio; lo que la hace rentable es que vea el peldaño siguiente
 * y le salga a cuenta subir. Por eso esto se pinta en el CARRITO y en la FICHA,
 * no en el checkout: cuando llega al checkout ya ha decidido, y además el
 * checkout de Shopify no se puede tocar sin plan Plus.
 *
 * El importe que manda es el SUBTOTAL de la cesta, que es sobre lo que Shopify
 * decide el porte (`TOTAL_PRICE` de las condiciones de envío).
 */
(function () {
  var TRAMOS = [
    { hasta: 30, precio: 4.95 },
    { hasta: 50, precio: 3.95 },
    { hasta: 70, precio: 2.95 },
    { hasta: Infinity, precio: 0 },
  ];
  function FT(s) { return window.FT ? window.FT(s) : s; }
  function eur(n) {
    return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function tramoDe(t) { for (var i = 0; i < TRAMOS.length; i++) if (t < TRAMOS[i].hasta) return i; return 3; }

  function pintar(total) {
    var i = tramoDe(total), sig = TRAMOS[i + 1], falta = sig ? (TRAMOS[i].hasta - total) : 0;
    var h = '<div class="fke-tit">🚚 <b>' + FT('Gastos de envío') + '</b>';
    h += i === 3
      ? '<span class="fke-gratis">' + FT('¡Envío gratis!') + '</span>'
      : '<span class="fke-falta">' + FT('Ahora pagas') + ' ' + eur(TRAMOS[i].precio) + '</span>';
    h += '</div><div class="fke-barra">';
    for (var k = 0; k < 4; k++) {
      h += '<div class="fke-seg' + (k <= i ? ' on' : '') + (k === i ? ' aqui' : '') + (k === 3 ? ' libre' : '') + '"><i></i></div>';
    }
    h += '</div><div class="fke-pasos">';
    var ETI = [FT('hasta 30 €'), '30 – 50 €', '50 – 70 €', FT('más de 70 €')];
    for (var j = 0; j < 4; j++) {
      h += '<div class="fke-paso' + (j <= i ? ' on' : '') + (j === i ? ' aqui' : '') + (j === 3 ? ' libre' : '') + '">'
        + '<b>' + (TRAMOS[j].precio ? eur(TRAMOS[j].precio) : FT('GRATIS')) + '</b>' + ETI[j] + '</div>';
    }
    h += '</div>';
    if (sig) {
      h += '<p class="fke-empuje">' + FT('Añade') + ' <b>' + eur(falta) + '</b> '
        + (i === 2
          ? FT('y <b>el envío es gratis</b>.')
          : FT('y el envío baja a') + ' <b>' + eur(sig.precio) + '</b>.')
        + '</p>';
    } else {
      h += '<p class="fke-empuje ok">' + FT('Tienes <b>envío gratis</b>. Bien jugado.') + '</p>';
    }
    return h;
  }

  function poner(total) {
    // SOLO EL CARRITO, y esto hay que decirlo porque ya falló una vez: en este
    // tema `.drawer__footer` es el pie del cajón del MENÚ, no el del carrito
    // (no hay `cart-drawer`), así que la escalera salía también dentro del menú
    // hamburguesa y en el móvil se veía dos veces, arriba y abajo.
    //
    // Se listan sitios de carrito de varios temas —por si algún día se cambia—
    // y se descarta cualquiera que cuelgue de un cajón de menú.
    var sitios = document.querySelectorAll(
      '.cart__footer, #main-cart-footer, cart-drawer .drawer__footer, #CartDrawer .drawer__footer, .cart-drawer__footer');
    for (var i = 0; i < sitios.length; i++) {
      var s = sitios[i];
      if (s.closest('menu-drawer, #MenuDrawer, .menu-drawer, .menu-drawer__footer')) continue;
      var caja = s.querySelector('.fke');
      if (!caja) {
        caja = document.createElement('div');
        caja.className = 'fke';
        s.insertBefore(caja, s.firstChild);
      }
      caja.innerHTML = pintar(total);
    }
  }

  // ── LA FICHA DE PRODUCTO ───────────────────────────────────────────────
  // Aquí es donde el cliente decide si añade otra cosa, así que la escalera
  // tiene que estar antes del carrito. Se pinta lo que PASARÍA con este
  // artículo dentro: la cesta de ahora más su precio.
  function precioDeLaFicha() {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var p = m && m.product;
      if (p && p.variants && p.variants.length) {
        var sel = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var id = sel && Number(sel.value);
        var v = (id && p.variants.filter(function (x) { return Number(x.id) === id; })[0]) || p.variants[0];
        if (v && v.price != null) return Number(v.price) / 100;
      }
    } catch (e) { }
    return null;
  }
  function ponerEnFicha(totalCesta) {
    // OJO CON DÓNDE SE CUELGA. En este tema la página de producto NO lleva la
    // clase `template-product` sino `product-template`, y hay VEINTE formularios
    // de «añadir al carrito» en la página: el del producto y uno por cada
    // tarjeta de recomendados. Colgarse del primero que aparece pone la
    // escalera dentro de una tarjeta de la fila de abajo.
    var esFicha = /(^|\s)(product-template|template-product)(\s|$)/.test(document.body.className)
      || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta
          && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType === 'product');
    if (!esFicha) return;
    var form = document.querySelector('.product-form form[action*="/cart/add"]')
      || document.querySelector('product-form form[action*="/cart/add"]');
    if (!form) {
      // Último recurso: el primer formulario que NO sea de una tarjeta.
      var todos = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < todos.length; i++) {
        if (!todos[i].closest('.product-card, .card, .product-card__image-wrapper')) { form = todos[i]; break; }
      }
    }
    if (!form) return;
    var precio = precioDeLaFicha();
    if (precio == null) return;
    var caja = document.querySelector('.fke-ficha');
    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'fke fke-ficha';
      form.parentNode.insertBefore(caja, form.nextSibling);
    }
    var conEste = totalCesta + precio;
    caja.innerHTML = '<div class="fke-conEste">' + FT('Con este artículo en la cesta') + '</div>' + pintar(conEste);
  }

  // Si una versión anterior dejó la escalera en un sitio que ya no toca (el
  // cajón del menú), se retira: si no, el visitante que no recargue la sigue
  // viendo duplicada.
  function limpiar() {
    var malas = document.querySelectorAll('menu-drawer .fke, #MenuDrawer .fke, .menu-drawer__footer .fke');
    for (var i = 0; i < malas.length; i++) malas[i].remove();
  }

  function leer() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var t = (c.items_subtotal_price || c.total_price || 0) / 100;
        poner(t);
        ponerEnFicha(t);
        limpiar();
      })
      .catch(function () { });
  }

  document.addEventListener('DOMContentLoaded', leer);
  // El tema recarga el carrito por fetch: se vuelve a pintar cuando cambia.
  ['cart:refresh', 'cart:updated', 'variant:added', 'variant:change'].forEach(function (e) { document.addEventListener(e, leer); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) setTimeout(leer, 60);
  });
  var _f = window.fetch;
  window.fetch = function () {
    var p = _f.apply(this, arguments);
    try {
      var u = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0] || '');
      if (/\/cart\/(add|change|update)/.test(u)) p.then(function () { setTimeout(leer, 250); });
    } catch (e) { }
    return p;
  };
})();
